import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Unit Types shell component — hosts the nested list page via router-outlet.
 * Acts as a layout wrapper for the Unit Types sub-module routes.
 */
@Component({
  selector: 'app-unit-types',
  templateUrl: './unit-types.component.html',
  styleUrl: './unit-types.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
})
export class UnitTypesComponent {}
